import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "component-nav-sub" }
const _hoisted_2 = ["onClick"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
},
  setup(__props) {

const props = __props



let showList = ref(false);

function changeActive(): void {
  showList.value = true;
}

function removeActive(): void {
  // console.log(1);

  showList.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "drop-btn nav-link",
      onMouseenter: changeActive
    }, " 导航 ", 32),
    (_unref(showList))
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "nav-drop-list",
          onMouseleave: removeActive
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: { name: item.link },
              key: index,
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", { onClick: navigate }, _toDisplayString(item.label), 9, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})